import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import type { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { TIERS_PATH } from './paths'

export interface MenuTiersProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuTiers({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuTiersProps) {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={TIERS_PATH}
        selected={pathname.startsWith(TIERS_PATH)}
      >
        <ListItemIcon>
          <MilitaryTechOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={formatMessage({ id: 'avatarStudio.sidebar.tiers' })} />
      </MenuItem>
    </div>
  )
}
